var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8536 0.646446C19.6583 0.451185 19.3417 0.451185 19.1464 0.646446L15.9645 3.82843C15.7692 4.02369 15.7692 4.34027 15.9645 4.53553C16.1597 4.7308 16.4763 4.7308 16.6716 4.53553L19.5 1.70711L22.3284 4.53553C22.5237 4.7308 22.8403 4.7308 23.0355 4.53553C23.2308 4.34027 23.2308 4.02369 23.0355 3.82843L19.8536 0.646446ZM19.5 17L20 17L20 1L19.5 1L19 1L19 17L19.5 17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85355 17.3536C4.65829 17.5488 4.34171 17.5488 4.14645 17.3536L0.964467 14.1716C0.769204 13.9763 0.769204 13.6597 0.964467 13.4645C1.15973 13.2692 1.47631 13.2692 1.67157 13.4645L4.5 16.2929L7.32843 13.4645C7.52369 13.2692 7.84027 13.2692 8.03553 13.4645C8.2308 13.6597 8.2308 13.9763 8.03553 14.1716L4.85355 17.3536ZM4.5 1L5 1L5 17L4.5 17L4 17L4 1L4.5 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapMobileIcon);
export default __webpack_public_path__ + "static/media/swapMobileIcon.cbdd8339d5a549ae4f3e1c4bebaa09f0.svg";
export { ForwardRef as ReactComponent };